import { render, staticRenderFns } from "./MileageHistoryTable.vue?vue&type=template&id=64010c29&scoped=true"
import script from "./MileageHistoryTable.vue?vue&type=script&lang=js"
export * from "./MileageHistoryTable.vue?vue&type=script&lang=js"
import style0 from "./MileageHistoryTable.vue?vue&type=style&index=0&id=64010c29&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64010c29",
  null
  
)

export default component.exports